<template>
  <router-view />
</template>

<script>
export default {
  name: 'User.Consultations'
}
</script>

<style scoped>

</style>
